// extracted by mini-css-extract-plugin
export var buttonLeft = "Carousel-module--buttonLeft--7iGnf";
export var buttonRight = "Carousel-module--buttonRight--99Q50";
export var controls = "Carousel-module--controls--mYPE7";
export var wrapper = "Carousel-module--wrapper--hM9O+";